
export const LicensingIconsObj = {
	ggl: {
		url: "https://www.gluecksspiel-behoerde.de/de/",
		icon: "ggl",
		title: "GGL",
	},
	ssl: {
		url: "https://ssl.comodo.com/",
		icon: "comodo-secure",
		title: "Comodo Certification Authority",
	},
	"gambling-therapy": {
		url: "https://www.gamblingtherapy.org/",
		icon: "gambling-therapy",
		title: "Gordon Moody - Therapy for gambling addiction",
	},
	gamcare: {
		url: "http://www.gamcare.org.uk/",
		icon: "gamcare",
		title: "GamCare",
	},
	dswv: {
		url: "https://dswv.de/",
		icon: "dswv",
		title: "DSWV - German Sports Betting Association",
	},
	mga: {
		url: "https://authorisation.mga.org.mt/verification.aspx?lang=EN&company=9733bb6f-3517-4875-86b8-01bb8c8685fa&details=1",
		icon: "mga",
		title: "Malta Gaming Authority",
	},
	spillemyndigheden: {
		url: "https://spillemyndigheden.dk/",
		icon: "spillemyndigheden",
		title: "Tilladelse fra Spillemyndigheden",
	},
	stopspillet: {
		url: "https://www.stopspillet.dk",
		icon: "stopspillet",
		title: "StopSpillet",
	},
	rofus: {
		url: "https://www.rofus.nu/",
		icon: "rofus",
		title: "ROFUS - Register Over Frivilligt Udelukkede Spillere",
	},
	mitid: {
		url: "https://www.mitid.dk/",
		icon: "mitid",
		title: "MitID",
	},
	ludomani: {
		url: "https://ludomani.dk/",
		icon: "ludomani",
		title: "Ludomani",
	},
	ludomanibehandling: {
		url: "https://frederiksberg-centeret.dk/ludomani/ ",
		icon: "ludomanibehandling",
		title: "Ludomani behandling",
	},
	spelinspektionen: {
		url: "https://www.spelinspektionen.se/licensansokan/bolag-med-spellicens/",
		icon: "spelinspektionen",
		title: "Spelinspektionen",
	},
	stodlinjen: {
		url: "https://www.stodlinjen.se",
		icon: "stodlinjen",
		title: "Stödlinjen för spelare och anhöriga",
	},
	spelberoendes: {
		url: "https://spelberoende.se",
		icon: "spelberoendes",
		title: "Spelberoendes Riksförbund för spelare och anhöriga",
	},
	spelberoendegruppen: {
		url: "https://spelberoendegruppen.com",
		icon: "spelberoendegruppen",
		title: "Spelberoendegruppen - Riksorganisation för Spelberoende och Anhöriga",
	},
	folkhalsomyndigheten: {
		url: "https://www.folkhalsomyndigheten.se/livsvillkor-levnadsvanor/alkohol-narkotika-dopning-tobak-och-spel-andts/spel/",
		icon: "folkhalsomyndigheten",
		title: "Folkhälsomyndigheten (Fohm)",
	},
};

